import IlustracaoDestaque from 'assets/img/destaque-ilustracao.png';

import { Vista } from '../realizacoes-do-semestre';

const VAZIO: Record<Vista, { titulo: string; texto: string }> = {
  minhas: {
    titulo: 'Nenhuma realização cadastrada por você neste ciclo',
    texto: 'Quando você cadastrar uma Realização Destaque, ela aparece aqui para você acompanhar a apreciação pela liderança.',
  },
  participacoes: {
    titulo: 'Nenhuma participação neste ciclo',
    texto:
      'Quando alguém incluir você como participante de uma Realização Destaque, ela aparece aqui para você acompanhar a apreciação e ajustar seu percentual de atuação.',
  },
};

/** Estado vazio da lista do ciclo, com o texto de cada vista. */
export default function VazioDoSemestre({ vista }: { vista: Vista }) {
  return (
    <div className="flex flex-wrap items-center gap-[22px] rounded-jj-lg border border-dashed border-surface-300 bg-brand-white px-[26px] py-6">
      <img src={IlustracaoDestaque} alt="" className="h-auto w-[118px] shrink-0" />
      <div className="flex min-w-[230px] flex-1 flex-col gap-2">
        <p className="m-0 font-display text-[15px] font-bold text-brand-blue-dark">{VAZIO[vista].titulo}</p>
        <p className="m-0 max-w-[440px] text-[12.5px] leading-[1.6] text-content-soft">{VAZIO[vista].texto}</p>
      </div>
    </div>
  );
}
